import { Row, Col } from 'react-bootstrap';
import { AtributosHelper, ENTIDADES_CON_FLUJO, TIPO_DECIMAL, TIPO_INTEGER } from '../../Utils';
import EditSection from '../PantallasEdit/EditSection/EditSection';
import { ControlledInput } from '../Inputs/ControlledInput';

function Atributos({ fuente, entidad, setEntidad, pantalla }) {
    const atributos = AtributosHelper.getAtributos(fuente, pantalla);

    if (atributos.length <= 0) {
        return <></>;
    }

    return (
        <>
            <EditSection title="Atributos">
                <Row>
                    {atributos.map((atributo, index) => {
                        const options = atributo.Valores
                            ? atributo.Valores.split(",").map((v, i) => ({
                                label: v,
                                value: i + 1,
                            }))
                            : [];

                        const name = `Atributo${index + 1}`;

                        if (atributo?.NoVisible === true) {
                            return <></>;
                        }

                        if (
                            ENTIDADES_CON_FLUJO.includes(fuente) &&
                            entidad?.FlujoTrabajoIdSec &&
                            atributo?.FlujoIdSec &&
                            entidad?.FlujoTrabajoIdSec != atributo?.FlujoIdSec
                        ) {
                            return <></>;
                        }

                        return (
                            <Col
                                key={`Atributo${index}`}
                                md={AtributosHelper.getSize(
                                    atributo.Tipo,
                                    atributo.LabelLongitud
                                )}
                                style={{ marginTop: "5px" }}
                            >
                                <ControlledInput
                                    propsContainer={{
                                        labelSize: AtributosHelper.getLabelSize(
                                            atributo.LabelLongitud
                                        ),
                                        colSize: atributo.LabelLongitud >= 3 ? 10 : 8,
                                    }}
                                    required={atributo.EsObligatorio}
                                    label={atributo.Label}
                                    name={name}
                                    type={AtributosHelper.getTipo(atributo.Tipo)}
                                    placeholder={atributo.Label}
                                    readOnly={atributo.SoloLectura}
                                    setState={setEntidad}
                                    options={options}
                                    style={{
                                        ...{
                                            textAlign:
                                                atributo.Tipo === TIPO_INTEGER ||
                                                atributo.Tipo === TIPO_DECIMAL
                                                    ? "end"
                                                    : "normal",
                                        },
                                        ...AtributosHelper.getStyle(
                                            atributo.Tipo,
                                            atributo.LabelLongitud
                                        ),
                                    }}
                                    onChange={AtributosHelper.getOnChange(
                                        atributo.Tipo,
                                        name,
                                        setEntidad
                                    )}
                                    value={AtributosHelper.getValor(
                                        atributo.Tipo,
                                        entidad[name] !== undefined ? entidad[name] : ""
                                    )}
                                />
                            </Col>
                        );
                    })}
                </Row>
            </EditSection>
        </>
    );
}

export default Atributos;